// Re-export from the consolidated operation DecimalsMask
// This ensures consistency across the codebase
const operationDecimalsMask = require('../../operation/DecimalsMask');

module.exports = operationDecimalsMask;
